import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '@src/store/store';
import { ROUTE_AUTH_FULL_PATH } from '@src/constants/URLS.const';

export function ProtectedRoute() {
  const accessToken = useSelector(
    (state: RootState) => state.user.user?.accessToken
  );

  const location = useLocation();

  if (!accessToken) {
    return (
      <Navigate
        to={`${ROUTE_AUTH_FULL_PATH}?redirect-url=${encodeURIComponent(
          location.pathname + location.search
        )}`}
        replace
      />
    );
  }

  return <Outlet />;
}
